import React from 'react';
import { PropTypes } from 'prop-types';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import styled from 'styled-components';

const Container = styled.div`
    .carousel .control-dots {
        position: static !important;
    }
`;

const CarouselArrow = styled.span`
    position: absolute;
    top: 49%;
    z-index: 1;
    opacity: 0.5;
    cursor: pointer;
    &:hover {
        opacity: 1;
    }
`;

const CarouselIndicator = styled.li`
    background: #d8d8d8;
    box-shadow: none;
    height: 12px;
    width: 12px;
    opacity: 1;
    display: inline-block;
    margin: 0 8px;
    border-radius: 50%;
    &.selected {
        background: #246eff;
        box-shadow: none;
        height: 12px;
        width: 12px;
        opacity: 1;
    }
`;

const PrevArrow = styled(CarouselArrow)`
    left: 20px;
    display: none;
`;
const NextArrow = styled(CarouselArrow)`
    right: 20px;
    display: none;
`;

const HeroCarousel = ({ children }) => (
    <Container className="fade-in-fast">
        <Carousel
            showThumbs={false}
            showStatus={false}
            infiniteLoop
            renderArrowPrev={(onClickHandler, hasPrev, label) => (
                <PrevArrow className="carousel-control-prev-icon" onClick={onClickHandler} aria-hidden="true" />
            )}
            renderArrowNext={(onClickHandler, hasPrev, label) => (
                <NextArrow className="carousel-control-next-icon" onClick={onClickHandler} aria-hidden="true" />
            )}
            renderIndicator={(onClickHandler, isSelected, index, label) => (
                <CarouselIndicator
                    className={isSelected ? 'selected' : ''}
                    onClick={onClickHandler}
                    aria-hidden="true"
                />
            )}
        >
            {children}
        </Carousel>
    </Container>
);

HeroCarousel.propTypes = {
    children: PropTypes.arrayOf(PropTypes.element),
};

export default HeroCarousel;
